module.exports = __webpack_public_path__ + "static/media/IMG_5995_2.21bcb60f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/photos/IMG_5995_2.jpg
// module id = 205
// module chunks = 0